// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 237 ? "pages" : chunkId) + "." + {"237":"4502b8e8","739":"217bc98e"}[chunkId] + ".css";
};